import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import PhproductshapeDashboard from '../PhproductshapeDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function PhproductshapePage() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(openDrawer(false));
    },[]);

    return (
        < PhproductshapeDashboard />
    )

}